import { sectionGap, wrap } from '../layout.js'
import SectionHead from './SectionHead.jsx'

/**
 * Three numbered steps. An ordered list, because the order is the message —
 * and on desktop a dashed rule runs between the cards so it reads as one
 * sequence rather than three unrelated boxes.
 */
export function HowItWorks({ t, desktop }) {
  return (
    <section
      id="how-it-works"
      aria-labelledby="how-it-works-title"
      style={{ ...wrap(desktop), paddingTop: sectionGap(desktop) }}
    >
      <SectionHead
        id="how-it-works-title"
        label={t.howLabel}
        title={t.howTitle}
        desktop={desktop}
      />
      <ol
        style={{
          display: 'grid',
          gridTemplateColumns: desktop ? '1fr 1fr 1fr' : '1fr',
          gap: desktop ? 34 : 16,
          margin: `${desktop ? 40 : 28}px 0 0`,
          padding: 0,
          listStyle: 'none',
        }}
      >
        {t.steps.map(([title, body], i) => (
          <li className="u-step" key={title}>
            <span className="u-step-num" aria-hidden="true">
              {i + 1}
            </span>
            <h3 style={{ fontSize: 19, margin: '16px 0 6px', letterSpacing: '-0.02em' }}>
              {title}
            </h3>
            <p style={{ margin: 0, fontSize: 15, color: 'var(--ink-2)', lineHeight: 1.55 }}>
              {body}
            </p>
          </li>
        ))}
      </ol>
    </section>
  )
}

export default HowItWorks
